import axios from 'axios'
import store from '../store'
import router from '@/router/index.js'
import {
  getToken,
  getDeviceId
} from '@/utils/auth'
import { getYunPanLoginUrl, getTelecomYunPanLoginUrl, getWatchYunPanLoginUrl,getWatchTelecomYunPanLoginUrl } from "@/api/extra";
import {
  Toast,
  Dialog
} from 'vant'
import { appReload } from "@/utils/location";

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // api的base_url
  timeout: 150000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // alert("config:"+JSON.stringify(config)+"，现在的token是："+getToken()+",另一个："+store.getters.token);
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  //当前访问地址  
  response => {
    var tarUrl = process.env.EXTERNAL_API + router.history.current.path;
    /**
     * code为非0是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 0) {

      // 401:未登录;
      if (res.code === 401) {

        // Dialog.alert({
        //     message: '您已被登出，请重新登录',
        //     confirmButtonText: '重新登录',
        //   }).then(() => {
        //     // on confirm
        //     store.dispatch('LogOut').then(() => {
        //       location.reload() // 为了重新实例化vue-router对象 避免bug
        //     })
        //   })
        //   .catch(() => {
        //     // on cancel
        //   });
        store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
          appReload();
        })
        return Promise.reject('error')
      }

      Toast.fail(res.msg);
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    var tarUrl = process.env.EXTERNAL_API + '#' + router.history.current.fullPath;
    console.log('err' + error) // for debug
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
          Toast.fail('登录信息已失效，请返回后重新登录');
          return Promise.reject(error)
          break;
        case 402:
          // 返回 402 微信code失效 重新访问login页面
          store.dispatch('LogOut').then(() => {
            router.push({
              path: '/login'
            })
          });
          break;
        case 411:
          //返回 411 移动云盘token失效 直接访问云盘授权
          Toast.clear();
          var deviceId = getDeviceId();
          getYunPanLoginUrl({ tarUrl: tarUrl, deviceId: deviceId }).then(res => {
            window.location.replace(res.data)
          })

          break;
        case 412:
          //返回 412 天翼云盘token失效 直接访问云盘授权
          Toast.clear();
          getTelecomYunPanLoginUrl({ tarUrl: tarUrl }).then(res => {
            window.location.replace(res.data)
          })

          break;
        case 421:
          //返回 421 未绑定手机号，引导前往绑定手机号
          Toast.clear();
          router.replace({
            path: '/bindPhone',
            query: {
              tarUrl: tarUrl
            }
          })

          break;
        case 431:
          //返回 431 手表移动云盘token失效 直接访问云盘授权
          Toast.clear();
          var deviceId = getDeviceId();
          getWatchYunPanLoginUrl({ tarUrl: tarUrl, deviceId: deviceId }).then(res => {
            window.location.replace(res.data)
          })

          break;
        case 451:
          
          //返回 451 手表天翼云盘token失效 直接访问云盘授权
          Toast.clear();
          var deviceId = getDeviceId();
          getWatchTelecomYunPanLoginUrl({ tarUrl: tarUrl, deviceId: deviceId }).then(res => {
            window.location.replace(res.data)
          })
          break;
        default:
          Toast.clear();
          Toast.fail('网络好像开小差了');
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js